import { useQuery } from "@tanstack/react-query";
import { ExternalLink, Lock } from "lucide-react";
import { integrationApi } from "@/services/integration";
import { PageShell, Pill, LoadingState } from "@/shared/ui/PageHeader";

export function QBIntegrationPage() {
  const platforms = useQuery({ queryKey: ["integration", "platforms"], queryFn: integrationApi.listPlatforms });
  if (platforms.isLoading) return <LoadingState />;
  if (platforms.isError) return (
    <div className="flex flex-col items-center gap-2 py-16 text-[13px] text-slate-500">
      <span>QuickBooks 集成加载失败</span>
      <button onClick={() => platforms.refetch()} className="rounded-md border border-slate-300 px-3 py-1 text-[12px] font-medium text-blue-600 hover:bg-blue-50">重试</button>
    </div>
  );
  const qb = (platforms.data ?? []).find((p) => p.slug === "qb");

  return (
    <PageShell
      title="QuickBooks 集成"
      subtitle="v1 业务壳 · v1.5 接 QB API（OAuth2）"
      actions={
        qb && (
          <Pill tone={qb.status === "connected" ? "success" : "muted"}>
            {qb.status === "disconnected" ? "v1 未启用" : qb.status}
          </Pill>
        )
      }
    >
      <section className="rounded-xl border border-slate-200 bg-white p-6">
        <h3 className="mb-3 text-base font-semibold">同步范围（v1.5）</h3>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {[
            ["Invoice 我→QB", "我们发的发票 同步到 QB"],
            ["Customer 双向", "客户主数据"],
            ["Payment QB→我", "客户在 QB 付款 同步回我"],
            ["Expense 我→QB", "成本 / 费用单"],
            ["报表 QB→我", "P&L · Balance · Cashflow"],
            ["失败重试", "进 API 集成中心错误队列"],
          ].map(([k, v]) => (
            <div
              key={k}
              className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-[13px]"
            >
              <div className="font-semibold text-slate-900">{k}</div>
              <div className="text-[11px] text-slate-500">{v}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="rounded-xl border border-amber-200 bg-amber-50 p-5 text-[13px]">
        <div className="flex items-center gap-2 text-amber-900">
          <Lock className="h-4 w-4" /> <strong>v1 未连接 QuickBooks</strong>
        </div>
        <p className="mt-2 text-amber-800">
          v1.5 通过 OAuth2 真接入 · 仅老板 / 技术管理员可操作。
        </p>
        <a
          href="https://quickbooks.intuit.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-1.5 text-blue-700 underline"
        >
          访问 QuickBooks <ExternalLink className="h-3 w-3" />
        </a>
      </section>
    </PageShell>
  );
}
